'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _MaskManager = require('./MaskManager');

var _MaskManager2 = _interopRequireDefault(_MaskManager);

var _MaskReducer = require('./MaskReducer');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    showMask: (0, _MaskReducer.getMaskCount)(state.mask) > 0
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_MaskManager2.default);


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/mask/MaskManagerContainer.js
// module id = 330
// module chunks = 10